import React, { useContext, useEffect, useState } from "react";
import "./ScanMartStore.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faLocationDot,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { Rating } from "react-simple-star-rating";
import TrandBee from "./TrandBee";
import Veggies_Section_Card from "../../Common-Component/Veggies_Section_Card/Veggies_Section_Card";
import Online_Store from "../../Common-Component/Online_Store/Online_Store";
import { Col, Nav, Row, Spinner, Tab } from "react-bootstrap";
import Veiw_All_Card from "../../Common-Component/Veiw_All_Card/Veiw_All_Card";
import { Category } from "../../../utils/apis/Product/Product";
import { NearSellerGet } from "../../../utils/apis/master/Master";
import { Context } from "../../../utils/context";
import { sellerCategory } from "../../../utils/apis/SellerApi/SellerApi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SupermarketModal from "../../Common_modal/Supermarket-modal/SupermarketModal";
import Verticle_Categories from "./verticle_categories/Verticle_Categories";
import { encodeId } from "../../../utils/common";

const ScanMartStore = () => {
  const [addCartModal, setAddCartModal] = useState(false);
  const location = useLocation();
  const [selectId, setSelectId] = useState("");
  const queryParams = new URLSearchParams(location.search);
  const category_id = queryParams.get("category_id");
  const { IMG_URL, getData, triggerCartUpdate, currentLocation } =
    useContext(Context);

  const [category, setCategory] = useState([]);
  const getCategory = async () => {
    const res = await Category();
    if (res?.success) {
      setCategory(res?.data);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    setSelectId(category_id);
  }, [category_id]);

  const [store, setStore] = useState([]);
  const getAllStores = async (selectId) => {
    const city =
      currentLocation?.formatted_address || currentLocation?.city ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";

    const res = await getData(
      `/shop?category_id=${selectId || ""}&city=${encodeURIComponent(city)}`,
    );

    if (res?.success) {
      setStore(res.data);
    }
  };
  useEffect(() => {
    getAllStores(selectId);
  }, [selectId,currentLocation]);
  const navigate = useNavigate();

  // const [city, setCity] = useState(null);

  // useEffect(() => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const { latitude, longitude } = position.coords;

  //         // Fetch city name using reverse geocoding
  //         fetch(
  //           `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${latitude}&lon=${longitude}`
  //         )
  //           .then((response) => response.json())
  //           .then((data) => {
  //             setCity(data.address.city);
  //           })
  //           .catch((error) => {
  //             console.error("Error fetching city:", error);
  //           });
  //       },
  //       (error) => {
  //         console.error("Error getting location:", error);
  //       }
  //     );
  //   } else {
  //     console.error("Geolocation is not supported by this browser.");
  //   }
  //   getCategory();
  //   // getSeller();
  //   getAllStores();
  // }, [city]);

  useEffect(() => {
    triggerCartUpdate();
  }, [addCartModal]);

  return (
    <>
      <section className="near_mart_store">
        <div className="container">
          <div className="all_content_holder">
            <div className="left_side">
              <Verticle_Categories
                selectId={selectId}
                setSelectId={setSelectId}
                category={category}
                // onCategorySelect={(item) => {
                //   if (item === "All") {
                //     getAllStores();
                //   } else {
                //     getStoresByCategory(item.id);
                //   }
                // }}
              />
            </div>

            <div className="right_side_div">
              <div className="all_store_holder">
                {store?.length > 0 ? (
                  store.map((value, index) => {
                    return (
                      <div
                        className="store_div"
                        // onClick={() => {
                        //   navigate("/store-details");
                        // }}
                        onClick={() =>
                          navigate(`/store-details/${encodeId(value.id)}`)
                        }
                      >
                        <div className="img_holder">
                          <img
                            src={IMG_URL + value?.logo}
                            className="store_img"
                          />
                        </div>

                        <div className="title_holder">
                          <p className="title_text">{value?.shop_name}</p>
                          <p className="rating_text">
                            <FontAwesomeIcon
                              icon={faStar}
                              className="star_icon"
                            />
                            {Number(value?.average_rating).toFixed(2)}
                          </p>
                        </div>

                        <p className="away_text">
                          {value?.user?.vender_app_setup?.delivery_time || 10}{" "}
                          minutes away from your location
                        </p>
                        <p className="location">
                          <FontAwesomeIcon
                            icon={faLocationDot}
                            className="location_icon"
                          />
                          {value?.area}, {value?.city?.name}
                        </p>
                      </div>
                    );
                  })
                ) : (
                  <div className="no-products-found">
                    <h4 className="align-center">No Product Available</h4>
                  </div>
                )}
              </div>
            </div>
          </div>

          <SupermarketModal
            show={addCartModal}
            onHide={() => setAddCartModal(false)}
          />
        </div>
      </section>
    </>
  );
};

export default ScanMartStore;
